import { useMemo } from "react";
import * as THREE from "three";

export const useLogoGeometry = (depth = 0.32) =>
  useMemo(() => {
    const gap = Math.PI * 0.3;
    const r = 0.68;
    const ir = 0.36;
    const s = new THREE.Shape();
    s.absarc(0, 0, r, gap, Math.PI * 2 - gap, false);
    s.lineTo(Math.cos(gap) * ir, -Math.sin(gap) * ir);
    s.absarc(0, 0, ir, -gap, gap, true);
    s.closePath();
    const geo = new THREE.ExtrudeGeometry(s, {
      depth,
      bevelEnabled: true,
      bevelThickness: 0.035,
      bevelSize: 0.035,
      bevelSegments: 4,
      curveSegments: 48,
    });
    geo.center();
    return geo;
  }, [depth]);

const LogoMark3D = ({ scale = 1, glass = true, chromeColor = "#f5f5f5", ...props }) => {
  const geometry = useLogoGeometry();
  return (
    <group scale={scale} rotation={[-0.15, 0, 0]} {...props}>
      <mesh geometry={geometry}>
        <meshStandardMaterial color={chromeColor} metalness={1} roughness={0.12} envMapIntensity={1.6} />
      </mesh>
      {glass && (
        <mesh geometry={geometry} scale={1.16}>
          <meshStandardMaterial
            color="#ffffff"
            metalness={0.9}
            roughness={0.05}
            transparent
            opacity={0.16}
            envMapIntensity={1.4}
            depthWrite={false}
          />
        </mesh>
      )}
    </group>
  );
};

export default LogoMark3D;
